<template>
    <div>


        <sg-items-block name='Получать квитанцию по электронной почте (только для квитанций ООО «ВЦ ЖКХ» г.Барнаул, г.Новоалтайск, МУП "РКЦ" г.Рубцовск)'>

            <template v-for="(card, i) in userInfo.cards">


                <v-list-item :key="card.pan" :disabled="!hasEmail" style="min-height: 56px"
                    @click="toggleSetting(card.pan)">

                    <v-list-item-content class="d-block">

                        <v-list-item-title>
                            {{card.main ? 'Основная карта' : card.comment}}
                        </v-list-item-title>

                        <v-list-item-subtitle>
                            {{card.pan}}
                        </v-list-item-subtitle>


                    </v-list-item-content>

                    <v-list-item-action>



                        <sg-switch v-if="hasEmail" :input-value="values[card.pan]" readonly
                            :loading="loadings[card.pan]" :disabled="!hasEmail" />

                        <v-icon v-else>mdi-lock</v-icon>
                    </v-list-item-action>

                </v-list-item>

                <v-divider v-if="i < userInfo.cards.length -1" style="margin-left: 16px" :key="'d-'+i" />

            </template>
        </sg-items-block>


        <v-alert v-if="hasEmail" class="text-body-2 mt-2" type="info" text :icon="false">

            Внимание! В случае получения квитанции на электронный адрес, печать квитанции на бумажном носителе и её
            доставка в почтовый ящик не производится
        </v-alert>



        <v-alert v-else class="text-body-2 mt-2" type="info" text :icon="false">
            Для того чтобы воспользоваться данной функцией вам необходимо привязать адрес электронной почты

            <div class="d-flex justify-end mt-2">
                <v-btn color="primary" small outlined :to="{name: 'wv-settings-email-edit'}">Указать</v-btn>
            </div>
        </v-alert>


        <sg-nav-back-btn class="mt-3" />
    </div>
</template>

<script>
    import settingsMixin from './settingsMixin'

    export default {
        mixins: [settingsMixin],


        computed: {

            values() {
                return this.userInfo.cards.reduce((map, card) => {

                    map[card.pan] = this.userInfo.settings.receiptEmail.includes(card.pan)
                    return map

                }, {})
            }
        },

        created() {
            this.userInfo.cards.forEach(card => {

                this.$set(this.loadings, card.pan, false)

            })


        },


        data() {
            return {

                loadings: {},

            }
        },
        methods: {



            toggleSetting(pan) {

                if (this.loadings[pan]) return
                if (!this.hasEmail) return


                let toSend = Object.entries(this.values).filter(entry => entry[1]).map(entry => entry[0])

                if (this.values[pan]) {

                    let indexToRemove = toSend.indexOf(pan)

                    if (indexToRemove > -1) {

                        toSend.splice(indexToRemove, 1)
                    }

                } else {


                    toSend.push(pan)
                }


                this.loadings[pan] = true

                /*         this.$store.dispatch('settings/SET_SETTING', { settingName: 'receiptEmail', newValue: toSend })

                        .finally(()=> {
                            this.loadings[pan] = false
                        }) */

                this.changeSettings('receiptEmail', toSend)
                    .finally(() => {
                        this.loadings[pan] = false
                    })

            }

        }

    }
</script>

<style>

</style>